export default {
  title: "dark",
  colors: {
    white: "#1C1C1C",
    primary: "rgb(27, 20, 20)",
    primary2: "rgba(27, 20, 20, 0.75)",
    primary3: "rgba(27, 20, 20, 0.75)",
    secondary: "rgba(255, 0, 0, 0.9)",
    secondary2: " rgba(255, 0, 0, 0.6)",
    grey1: "rgb(25, 32, 45)",
    grey2: "rgb(110, 128, 152)",
    grey3: "rgb(201, 201, 201)",
    grey4: "rgb(244, 246, 248)",
    grey5: "rgb(244, 246, 248)",
    negative: "rgb(230, 0, 0)",
    warning: "rgb(255, 205, 7)",
    sucess: "rgb(22, 136, 33)",
    information: "rgb(21, 91, 203)",
  },
};
